<div class="person-card" [ngStyle]="{ '--card-accent': statusColor }">

  <div class="corner-banner" [ngStyle]="{ 'background-color': modeBanner.color }">
    {{ modeBanner.text }}
  </div>

  <div class="card-layout">

    <div class="avatar-container">
      <img [src]="person?.profilePic || 'assets/images/avatars/0.png'" class="avatar" alt="{{ displayName }}"
        (error)="onImageError($event)" width="68" height="68" />
      <div class="status-indicator" [ngStyle]="{ 'background-color': statusColor }">
      </div>
    </div>

    <div class="info-container">
      <div class="name-line">
        <h5 class="name">{{ displayName }}</h5>
      </div>

      <div class="project-line" *ngIf="projectDisplay">
        <span class="project-label">Working on</span>
        <span class="project-name text-truncate">
          {{ projectDisplay }}
        </span>
      </div>

      <div class="project-line" *ngIf="!projectDisplay">
        <span class="project-label text-muted">
          {{ statusText }}
        </span>
      </div>

      <div class="time-line" *ngIf="person?.signIn || person?.signOut">

        <span class="time-badge in" *ngIf="person?.signIn">
          Time In: {{ person.signIn}}
        </span>

        <span class="time-badge out" *ngIf="person?.signOut">
          Time Out: {{ person.signOut}}
        </span>

      </div>
    </div>

  </div>

  <div class="task-divider"></div>

  <div class="task-section">

    <div class="task-row" (click)="onStatusClick('pending')">
      <div class="task-title">
        Pending
      </div>

      <div class="task-bar-wrapper">
        <div class="task-bar warning" [style.width.%]="pendingPercent">
        </div>
      </div>

      <div class="task-count warning">
        {{ taskCounts.pendingAssigned }}
        <span class="task-percent">
          ({{ pendingPercent | number:'1.0-0' }}%)
        </span>
      </div>
    </div>

    <div class="task-row" (click)="onStatusClick('inProgress')">
      <div class="task-title">
      </div>

      <div class="task-bar-wrapper">
        <div class="task-bar primary" [style.width.%]="inProgressPercent">
        </div>
      </div>

      <div class="task-count primary">
        {{ taskCounts.inProgress }}
        <span class="task-percent">
          ({{ inProgressPercent | number:'1.0-0' }}%)
        </span>
      </div>
    </div>

    <div class="task-row" (click)="onStatusClick('completed')">
      <div class="task-title">
        Completed
      </div>

      <div class="task-bar-wrapper">
        <div class="task-bar success" [style.width.%]="completedPercent">
        </div>
      </div>

      <div class="task-count success">
        {{ taskCounts.completed }}
        <span class="task-percent">
          ({{ completedPercent | number:'1.0-0' }}%)
        </span>
      </div>
    </div>

  </div>

</div>